import React, { FC } from "react";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { IGarageList } from "../../../interfaces/Interfaces";
import { IGarageListColumns } from "./GarageListColumns";
import { ILocation } from "../MapView";

interface Props {
    data: IGarageList[];
    columns: IGarageListColumns[];
    onDetailsClick?: (id: string) => void;
    onRowClick?: (location: ILocation) => void;
}

export const GarageTableRows: FC<Props> = ({
    data,
    columns,
    onDetailsClick,
    onRowClick,
}) => {
    return (
        <TableBody>
            {data.map((row) => (
                <TableRow
                    key={row.id}
                    onClick={() =>
                        onRowClick?.({
                            latitude: row.latitude.toString(),
                            longitude: row.longitude.toString(),
                            name: row.name,
                            address: row.address,
                        })
                    }
                    sx={{
                        cursor: "pointer",
                        height: "70px",
                        "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                    }}
                >
                    {columns.map((col) => {
                        const cellValue = row[col.param];
                        return (
                            <TableCell
                                key={col.param as string}
                                sx={{ p: 1, verticalAlign: "middle", ...col.cellStyle }}
                            >
                                {col.renderer ? (
                                    col.param === "id" && onDetailsClick ? (
                                        <col.renderer
                                            value={cellValue}
                                            handleDetailsClick={() =>
                                                onDetailsClick(String(cellValue))
                                            }
                                        />
                                    ) : (
                                        <col.renderer value={cellValue} />
                                    )
                                ) : (
                                    cellValue
                                )}
                            </TableCell>
                        );
                    })}
                </TableRow>
            ))}
        </TableBody>
    );
};
